// Wizard application components
import FormField from 'components/FormField'
import CurrencyField from 'components/FormField/CurrencyField'
import CurrencyFloatField from 'components/FormField/CurrencyFloatField'
import PercentageField from 'components/FormField/PercentageField'
import PhoneNumberField from 'components/FormField/PhoneNumberField'
import TextAreaField from 'components/FormField/TextAreaField'
import { DropdownField } from 'components/FormField/DropdownField'
import { DeductionsStep } from 'components/FormField/DeductionsStep'
import { TspLoansStep } from 'components/FormField/TspLoansStep'
import { DeductionTypeSelection } from 'components/FormField/DeductionsStep/DeductionTypeSelection'
import { DeductionsStepReview } from 'components/FormField/DeductionsStep/DeductionsStepReview'
import { TspLoanReview } from 'components/FormField/TspLoanReview'
import { SplitDateField } from 'components/FormField/SplitDateField'
import { format } from 'date-fns'
import { MultiSelect } from 'components/FormField/MultiSelect'
import FloatField from 'components/FormField/FloatField'
import IntegerField from 'components/FormField/IntegerField'
import MuiZipcodeField from 'components/FormField/MuiZipcodeField'

export const renderFormField = ({
  inputType,
  placeholder,
  label,
  required = false,
  onChange = (e) => console.log(e),
  onBlur = (e) => console.log(e),
  forceError,
  intakeAttribute,
  options,
  handleNext,
  autoFocus = false,
  disabled = false,
  hiddenLabel = false,
  tooltip,
  defaultDate,
  dateListTrim,
  optionMatchMethod,
  carrierMatchMethod,
  defaultErrorState,
  maxValue,
}) => {
  const moveToNext = (e) => {
    if (e.key === 'Enter') {
      handleNext?.()
    }
  }
  const sanitizeDate = (value) =>
    !Number.isNaN(new Date(value).getTime()) ? value : null
  switch (inputType) {
    case 'text':
      return (
        <FormField
          type="text"
          label={label}
          placeholder={placeholder}
          value={intakeAttribute || ''}
          onChange={(e) => onChange(e.target.value)}
          onBlur={onBlur}
          onKeyPress={moveToNext}
          autoFocus={autoFocus}
          disabled={disabled}
          tooltip={tooltip}
          required={required}
          defaultErrorState={defaultErrorState}
        />
      )
    case 'date':
      return (
        <FormField
          type="date"
          name={label}
          label={label}
          placeholder={placeholder}
          value={intakeAttribute || ''}
          onChange={(e) => onChange(sanitizeDate(e.target.value))}
          onBlur={onBlur}
          onKeyPress={moveToNext}
          autoFocus={autoFocus}
          disabled={disabled}
          tooltip={tooltip}
          required={required}
        />
      )
    case 'splitdate':
      return (
        <SplitDateField
          type="select"
          name={label}
          label={label}
          placeholder={placeholder}
          value={intakeAttribute || defaultDate}
          onChange={(e) => onChange(e)}
          onBlur={onBlur}
          onKeyPress={moveToNext}
          autoFocus={autoFocus}
          disabled={disabled}
          tooltip={tooltip}
          required={required}
          options={options}
          dateListTrim={dateListTrim || { start: 0, end: 119 }}
        />
      )
    case 'email':
      return (
        <FormField
          type="email"
          label={label}
          placeholder={placeholder}
          value={intakeAttribute || ''}
          onChange={(e) => onChange(e.target.value)}
          onBlur={onBlur}
          onKeyPress={moveToNext}
          autoFocus={autoFocus}
          disabled={disabled}
          tooltip={tooltip}
          required={required}
          defaultErrorState={defaultErrorState}
          forceError={forceError}
        />
      )
    case 'tel':
      return (
        <PhoneNumberField
          name={label}
          label={label}
          placeholder={placeholder}
          value={intakeAttribute || ''}
          onChange={(phoneNumberValue) =>
            onChange(phoneNumberValue ? phoneNumberValue : null)
          }
          onBlur={onBlur}
          onKeyPress={moveToNext}
          autoFocus={autoFocus}
          disabled={disabled}
          tooltip={tooltip}
          required={required}
          defaultErrorState={defaultErrorState}
          forceError={forceError}
        />
      )
    case 'int':
      return (
        <IntegerField
          type="number"
          name={label}
          label={label}
          placeholder={placeholder}
          value={intakeAttribute || ''}
          onChange={(integerValue) => onChange(integerValue)}
          onBlur={onBlur}
          onKeyPress={moveToNext}
          autoFocus={autoFocus}
          disabled={disabled}
          tooltip={tooltip}
          required={required}
          maxValue={maxValue}
        />
      )
    case 'floatField':
      return (
        <FloatField
          type="text"
          name={label}
          label={label}
          placeholder={placeholder}
          value={intakeAttribute || ''}
          onChange={(floatValue) => onChange(floatValue)}
          onBlur={onBlur}
          onKeyPress={moveToNext}
          autoFocus={autoFocus}
          disabled={disabled}
          tooltip={tooltip}
          required={required}
        />
      )
    case 'zipcode':
      return (
        <MuiZipcodeField
          type="text"
          name={label}
          label={label}
          placeholder={placeholder}
          value={intakeAttribute || ''}
          onChange={(zipcodeValue) =>
            onChange(zipcodeValue ? zipcodeValue : null)
          }
          onBlur={onBlur}
          onKeyPress={moveToNext}
          autoFocus={autoFocus}
          disabled={disabled}
          tooltip={tooltip}
          required={required}
        />
      )
    case 'currency':
      return (
        <CurrencyField
          type="currency"
          name={label}
          label={label}
          placeholder={placeholder}
          value={intakeAttribute || ''}
          onChange={(floatValue) => onChange(floatValue)}
          onBlur={onBlur}
          onKeyPress={moveToNext}
          autoFocus={autoFocus}
          disabled={disabled}
          tooltip={tooltip}
          required={required}
        />
      )
    case 'currencyFloat':
      return (
        <CurrencyFloatField
          type="currency"
          name={label}
          label={label}
          placeholder={placeholder}
          value={intakeAttribute || ''}
          onChange={(floatValue) => onChange(floatValue)}
          onBlur={onBlur}
          onKeyPress={moveToNext}
          autoFocus={autoFocus}
          disabled={disabled}
          tooltip={tooltip}
          required={required}
        />
      )
    case 'percentage':
      return (
        <PercentageField
          // type="percentage"
          name={label}
          label={label}
          placeholder={placeholder}
          value={intakeAttribute || ''}
          onChange={(floatValue) => onChange(floatValue)}
          onBlur={onBlur}
          onKeyPress={moveToNext}
          autoFocus={autoFocus}
          disabled={disabled}
          tooltip={tooltip}
          required={required}
        />
      )
    case 'select':
      return (
        <DropdownField
          intakeAttribute={intakeAttribute}
          options={options}
          label={label}
          placeholder={placeholder}
          hiddenLabel={hiddenLabel}
          onChange={onChange}
          moveToNext={moveToNext}
          autoFocus={autoFocus}
          disabled={disabled}
          tooltip={tooltip}
          required={required}
          optionMatchMethod={optionMatchMethod}
          carrierMatchMethod={carrierMatchMethod}
        />
      )
    case 'select-multiple':
      return (
        <MultiSelect
          intakeAttribute={intakeAttribute}
          options={options}
          label={label}
          placeholder={placeholder}
          hiddenLabel={hiddenLabel}
          onChange={onChange}
          moveToNext={moveToNext}
          autoFocus={autoFocus}
          disabled={disabled}
          tooltip={tooltip}
          required={required}
          optionMatchMethod={optionMatchMethod}
        />
      )
    case 'textArea':
      return (
        <TextAreaField
          type="text"
          label={label}
          placeholder={placeholder}
          value={intakeAttribute || ''}
          onChange={(e) => onChange(e.target.value)}
          onBlur={onBlur}
          // onKeyPress={moveToNext}
          autoFocus={autoFocus}
          disabled={disabled}
          tooltip={tooltip}
          required={required}
          defaultErrorState={defaultErrorState}
        />
      )
    case 'deduction':
      return <DeductionsStep />
    case 'deductionTypeSelection':
      return <DeductionTypeSelection />
    case 'deductionsReview':
      return <DeductionsStepReview />
    case 'tspLoan':
      return <TspLoansStep />
    case 'tspLoanReview':
      return <TspLoanReview />
    case 'displayOnly':
      return null
    default:
      return (
        <FormField
          type="text"
          label={label}
          placeholder={placeholder}
          value={intakeAttribute || ''}
          onChange={(e) => onChange(e.target.value)}
          onBlur={onBlur}
          onKeyPress={moveToNext}
          autoFocus={autoFocus}
          disabled={disabled}
          tooltip={tooltip}
          required={required}
        />
      )
  }
}
